import CryptoJS from 'crypto-js';

const ENCRYPTION_KEY = import.meta.env.VITE_ENCRYPTION_KEY;

/**
 * @param {string} encryptedData
 * @returns {Object}
 */
export const decryptData = (encryptedData) => {
    try {
        const parts = encryptedData.split(':');
        const iv = CryptoJS.enc.Hex.parse(parts[0]);
        const encryptedHex = parts[1];
        
        const encryptedData_CJS = CryptoJS.enc.Hex.parse(encryptedHex);
        
        const key = CryptoJS.enc.Utf8.parse(ENCRYPTION_KEY.padEnd(32, '0').slice(0, 32));
        
        const decrypted = CryptoJS.AES.decrypt(
            { ciphertext: encryptedData_CJS },
            key,
            {
                iv: iv,
                mode: CryptoJS.mode.CBC,
                padding: CryptoJS.pad.Pkcs7
            }
        );
        
        const jsonString = decrypted.toString(CryptoJS.enc.Utf8);
        
        if (!jsonString) {
            throw new Error('Decryption failed - wrong key or corrupted data');
        }
        
        return JSON.parse(jsonString);
    } catch (error) {
        console.error('Decryption error:', error);
        throw error;
    }
};